const SystemHealthDashboard = () =>
  import('../screens/HealthDashboard/SystemHealthDashboard/SystemHealthDashboard.vue');
const BanksHealthDashboard = () =>
  import('../screens/HealthDashboard/BanksHealthDashboard/BanksHealthDashboard.vue');

export default [
  {
    component: SystemHealthDashboard,
    meta: {
      activeSidebarItemId: 'health-system',
      authority: 'health_dashboard:index',
      pageTitle: 'System Health',
    },
    name: 'health-system',
    path: '/health-system',
  },
  {
    component: BanksHealthDashboard,
    meta: {
      activeSidebarItemId: 'health-banks',
      authority: 'health_dashboard:index',
      pageTitle: 'Banks Health',
    },
    name: 'health-banks',
    path: '/health-banks',
  },
];
